/*
 * Inviews
 * epicaffect
 */

;(function($){
    
    $('h1.border-bottom').bind('inview', function(event, visible, visiblePartX, visiblePartY) {
        if (visible) {
            $(this).addClass( 'visible' );
        } else {
            $(this).removeClass( 'visible' );
        }
    });

    $('blockquote').bind('inview', function(event, visible, visiblePartX, visiblePartY) {
        if (visible) {
            $(this).addClass( 'visible' );
        } else {
            $(this).removeClass( 'visible' );
        }
    });
    
}(jQuery));
